import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import BoxscoreTeamContainer from './boxscore/BoxscoreTeamContainer';
import { BoxscoreTabsWrapper, BoxscoreWrapper, BoxscoreTeamsGridWrapper, GameInfoWrapper, GameInfo, BoxScoreViewTypes, BoxScrollWrapper } from './Boxscore.style';
import FieldList from './boxscore/boxscoreTeam/boxscoreInfo/FieldList';
import types from './boxscore//boxscoreTeam/config/TeamTypes';
import TeamTabs from './TeamTabs';
import useTracking from '@gameday/utils/hooks/useTracking';
import { getActiveTeamTabState } from './store/selectors/getActiveTeamTabState';

const { HOME, AWAY } = types;

const Boxscore = ({
    info,
    awayName,
    homeName,
    showBullpen,
    showBench,
    viewType
}) => {
    const Tracking = useTracking();
    const { isHomeBatting } = useSelector(getActiveTeamTabState);
    const [expanded, setExpanded] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const team = activeTab === 1 ? HOME : AWAY;
    const displayGameInfoInline = viewType !== BoxScoreViewTypes.WIDE;
    const syncBoxscoreInfo = useCallback((expanded) => {
        setExpanded(expanded);
    }, [setExpanded]);

    const dataAttr = {
        'data-active-tab': team
    };

    const onClick = useCallback((e) => {
        const text = e?.currentTarget?.innerText || '';
        const selectedIndex = e?.currentTarget?.getAttribute('data-index') * 1;
        setActiveTab(selectedIndex);
        const cfg = {
            componentName: ['Box', text],
            selectedIndex: e?.currentTarget?.dataset?.index * 1,
            text,
            activity: 'Tab Click'

        };

        Tracking.track.track_click(cfg);
    }, [setActiveTab]);

    useEffect(() => {
        setActiveTab(isHomeBatting ? 1 : 0);
    }, [isHomeBatting]);

    return (
        <BoxscoreWrapper {...dataAttr} viewType={viewType}>
            <BoxscoreTabsWrapper viewType={viewType}>
                <TeamTabs
                    team={team}
                    homeName={homeName}
                    awayName={awayName}
                    onClick={onClick}
                    activeTab={activeTab}
                />
            </BoxscoreTabsWrapper>
            <BoxScrollWrapper>
                <BoxscoreTeamsGridWrapper viewType={viewType}>
                    <BoxscoreTeamContainer displayGameInfoInline={displayGameInfoInline} list={info} showBench={showBench} showBullpen={showBullpen} team={AWAY} syncBoxscoreInfo={syncBoxscoreInfo} expanded={expanded}/>
                    <BoxscoreTeamContainer displayGameInfoInline={displayGameInfoInline} list={info} showBench={showBench} showBullpen={showBullpen} team={HOME} syncBoxscoreInfo={syncBoxscoreInfo} expanded={expanded}/>
                </BoxscoreTeamsGridWrapper>

                {(!displayGameInfoInline && info.length > 0) && <GameInfoWrapper>
                    <GameInfo
                        visibleContent={ <FieldList list={info} divider={': '} /> }
                        showButton={ false }
                    />
                </GameInfoWrapper>
                }
            </BoxScrollWrapper>

        </BoxscoreWrapper>
    );
};

Boxscore.propTypes = {
    info: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
    })),
    awayName: PropTypes.string,
    homeName: PropTypes.string,
    showBullpen: PropTypes.bool,
    showBench: PropTypes.bool,
    isHomeBatting: PropTypes.number,
    viewType: PropTypes.string
};

export default Boxscore;
